module.exports = __webpack_public_path__ + "static/media/app@3x.66b1143a.png";